import { FC } from "react";
import KickImage from 'Reuseables/KickImage';
import { Modal } from "react-bootstrap";

//Components
import DeliveryMethod from "../DeliveryMethod/index";
import PickupAddress from "../PickupAddress/index";
import SelectLogistic from "../SelectLogistic/index";
import LogisticConfirmation from "../LogisticConfirmation/index";
import OutOfReach from "../OutOfReach/index";
import PickupCreated from "../PickupCreated/index";
import PickupScheduled from "../PickupSchedule/index";
import PickupNotes from "../PickupNotes/index";
import PackageLocation from "../PackageLocation/index";
import PickupScheduledDetails from "../PickupScheduledDetails/index";
import RequestCancelPickup from "../RequestCancelPickup/index";
import PickupDetails from "../PickupDetails/index";
import RequestCancelled from "../RequestCancelled/index";
import Dropoff from "../Dropoff/index";

//Assets
import RoundCloseButton from "../../../../images/round-close-button.png";

//Types
import { ComponentProps } from "./definitions";

const Component: FC<ComponentProps> = ({
  isOpen,
  process,
  sale_id,
  order_id,
  selectedAddress,
  selectedLogistic,
  pickupCreatedData,
  seller_responded,
  addresses,
  defaultAddress,
  isConsignments,
  onHideAndUpdate,
  deliveryMethodContinue,
  submitDropoffHandler,
  pickupAddressContinue,
  selectLogisticBack,
  selectLogisticContinue,
  logisticConfirmationContinue,
  logisticConfirmationBack,
  onHideHandler,
  toPickupAddress,
  toPickupScheduled,
  toPickupNotes,
  toPickupScheduledDetails,
  toPickupDetails,
  toDeliveryMethod,
  toPickupCreated,
  toRequestCancelPickup,
  toPickupCancelled,
  toOutOfReach,
  pickupUnmountCallback
}) => {
  // Render Process
  const RenderProcess = () => {
    switch (process) {
      case "delivery-method": return (<DeliveryMethod continueAction={deliveryMethodContinue} />)

      // Pickup process
      case "pickup-address": return <PickupAddress
        addresses={addresses}
        defaultAddress={defaultAddress}
        selectedAddress={selectedAddress}
        onBack={toDeliveryMethod}
        continueAction={pickupAddressContinue}
        pickupUnmountCallback={pickupUnmountCallback}
      />
      case "select-logistic": return <SelectLogistic seller_responded={seller_responded} selectedAddress={selectedAddress} sale_id={sale_id} isConsignments={isConsignments} onBack={selectLogisticBack} toOutOfReach={toOutOfReach} continueAction={selectLogisticContinue} />
      case "logistic-confirmation": return <LogisticConfirmation
        selectedLogistic={selectedLogistic}
        seller_shipping_id={selectedAddress?.id}
        sale_id={sale_id}
        isConsignments={isConsignments}
        onBack={logisticConfirmationBack}
        continueAction={logisticConfirmationContinue}
      />
      case "out-of-reach": return <OutOfReach toDeliveryMethod={toDeliveryMethod} toPickupAddress={toPickupAddress} />
      case "pickup-created": return <PickupCreated pickupCreatedData={pickupCreatedData} continueAction={toPickupScheduled} />
      case "pickup-scheduled": return <PickupScheduled
        onBack={toPickupCreated}
        continueAction={toPickupNotes}
        order_id={order_id}
      />
      case "pickup-notes": return <PickupNotes onOK={toPickupScheduledDetails} />
      case "pickup-scheduled-details": return <PickupScheduledDetails order_id={order_id} onCancel={toRequestCancelPickup} onPickupDetails={toPickupDetails} />
      case "request-cancel-pickup": return <RequestCancelPickup order_id={order_id} onBack={toPickupScheduledDetails} requestCancelled={toPickupCancelled} />
      case "pickup-cancelled": return <RequestCancelled canceled={onHideHandler} />
      case "pickup-details": return <PickupDetails onBack={toPickupScheduledDetails} seeNote={toPickupNotes} order_id={order_id} />
      case "pickup-location": return <PackageLocation onHide={onHideHandler} order_id={order_id} toPickupDetails={toPickupDetails} />

      // Dropoff process
      case "dropoff": return <Dropoff submitSuccess={submitDropoffHandler} sale_id={sale_id} onBack={toDeliveryMethod} isConsignments={isConsignments}/>

      default:
        return <div />
    }
  }
  return (
    <Modal centered id="modal-shipper" show={isOpen} onHide={onHideHandler}>
      <KickImage onClick={onHideHandler} className='close-btn' src={RoundCloseButton} alt='close-btn' />
      {RenderProcess()}
    </Modal>
  )
}
Component.defaultProps = {};

export default Component;